// エントリーポイント用のjsファイル ファイルを追加した場合は読み込みを追加
require("./drawer");
require("./radioButton");
require("./back-to-top");
require("./fix-pagination");
// require('./script');
// require('./utils');
